import { render, staticRenderFns } from "./EditVehicleComponent.vue?vue&type=template&id=6dce60b9"
import script from "./EditVehicleComponent.vue?vue&type=script&lang=js"
export * from "./EditVehicleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports